import React from 'react';
import { useDispatch } from 'react-redux';

import { Utils } from 'app/main/components';
import CompaniesMap from 'app/main/modules/companies/components/CompaniesMap';

export default function MarketingActionsDetailsSectionMap({ maacUid }: { maacUid: string }) {
	const dispatch = useDispatch();

	const [companies, setCompanies] = React.useState<any[]>([]);

	React.useEffect(() => {
		Utils.executeStored({
			action: 'st_marketingactions_rows_list',
			dispatch,
			params: {
				n_page: 1,
				n_rows: 1000, // TODO: paginare?
				filters: [
					{
						filt_field: 'marw_maac_uid',
						filt_clause: 'equals',
						filt_value: maacUid
					},
					{
						filt_field: 'marw_table',
						filt_clause: 'equals',
						filt_value: 'companies'
					}
				]
			},
			successHandler: response => {
				setCompanies(response.data.list || []);
			}
		});
	}, [dispatch, maacUid]);

	return <CompaniesMap companies={companies} />;
}
